import React from 'react';
import './Homework.css';

// A percentage bar: blue while in progress, amber when little is done, green at 100%.
const ProgressBar = ({ percent = 0, total = 1 }) => {
  const state = percent >= 100 ? 'full' : percent < 34 && total > 0 ? 'low' : 'mid';
  return (
    <div className="hw-bar-row">
      <div className="hw-bar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}>
        <div className="hw-bar__fill" data-state={state} style={{ width: `${percent}%` }} />
      </div>
      <span className="hw-pct" data-state={state}>{percent}%</span>
    </div>
  );
};

export default ProgressBar;
